<template>
  <Card>
    <span slot="title">理疗师管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getPhysioPerson)" class="fr">刷新</el-button>
    <div slot="content" class="physiowrap">
      <!-- 条件查询 -->
      <div class="search"> 
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="姓名">
            <el-input v-model="searchForm.name" placeholder="请输入姓名"/>
          </el-form-item>
          <el-form-item label="医馆" v-if="!deptId">
            <el-select v-model="searchForm.deptId" placeholder="请选择医馆">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getPhysioPerson, searchForm)" >查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getPhysioPerson, { name: null, deptId: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addPhysioPerson" v-if="deptId">新增理疗师</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deletePhysioPersonList">批量删除</el-button>
      </div>
      <!-- 操作员列表 -->
      <el-table v-loading="loading" @selection-change="val => $handleSelectionChange(val, true)"
        ref="multipleTable" :data="physioPersonList" :max-height="tableHeight" border>
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="name" label="姓名"/>
        <el-table-column prop="deptName" label="所属医馆" v-if="!deptId"/>
        <el-table-column prop="createTime" label="创建时间" min-width="150"/>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="scope.row.status == '1'" @click="deletePhysioPerson(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="scanEdit" title="新增理疗师" :visible.sync="dialogVisible" width="360px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入理疗师姓名"/>
          </el-form-item>
          <el-form-item label="医馆" prop="deptId">
            <el-select v-model="editForm.deptId" placeholder="请选择理疗师所在医馆">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getPhysioPerson)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import { executionList, executionAdd, executionDelete } from "@/api/physioexecute"; // 获取理疗师请求
export default {
  name: "PhysioPerson",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { name: null, deptId: null }, // 查询表单
      physioPersonList: [], // 操作员列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      imgVisible: false, // 图片弹框
      multipleSelection: [], // 多选选中项
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        name: [{required: true, message: "姓名不能为空！", trigger: "blur"}],
        deptId: [{required: true, message: "医馆不能为空", trigger: "change"}]
      }, // 验证规则
      deptId: this.$session.get('deptId'), // 当前医馆id
      deptOptions: this.$session.get('options'), // 医馆列表
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getPhysioPerson(); // 请求操作员列表
  },
  methods: {
    // 请求所有理疗师列表
    async getPhysioPerson() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await executionList(params);
      if (code == 200) {
        if (total > 0) rows.forEach(item => { 
          this.deptOptions.forEach(items => {
            if (item.deptId == items.value) item.deptName = items.label;
          })
        });
        this.total = total;
        this.physioPersonList = rows;
      }
      this.loading = false;
    },
    // 新增操作员
    addPhysioPerson() {
      this.dialogVisible = true;
      this.dialogTitle = "新增理疗师";
      this.editForm = { name: null, deptId: this.deptId };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          executionAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增理疗师成功！");

            this.dialogVisible = false;
            this.$refresh(this.getPhysioPerson);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 删除理疗师
    deletePhysioPerson(row) {
      this.$confirm('确认删除该辅料？').then(_ => { this.del(row.id) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await executionDelete(id);
      if (code == 200) this.$message.success("删除理疗师成功！");
      this.$refresh(this.getPhysioPerson);
    },
    // 批量删除理疗师
    deletePhysioPersonList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何理疗师，请选择后再试！");
      else {
        selected.forEach(item => { selectedId.push(item.id) });
        this.$confirm('确认删除该理疗师？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    }
  }
};
</script>

<style lang="less" scoped>
.physiowrap {
  & > div:not(:last-child) {
    margin-bottom: 20px;
  }
  .scanEdit {
    .el-form-item {
      width: 460px;
    }
    /deep/.el-input, /deep/.el-form-item__content {
      width: 270px;
    }
  }
}
</style>